// Native customer signup only; the existing welcome automation owns discount delivery.
if (!customElements.get('peak-floating-offer')) {
  customElements.define('peak-floating-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.launcher = this.querySelector('.peak-offer__launcher');
      this.trigger = this.querySelector('.peak-offer__trigger');
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.dismissKey = 'peak-newsletter-offer-dismissed';
      let dismissed = false;
      try { dismissed = sessionStorage.getItem(this.dismissKey) === '1'; } catch { /* Storage is optional. */ }
      this.launcher.hidden = dismissed && !window.Shopify?.designMode;
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('.peak-offer__close').addEventListener('click', () => this.dialog.close(), options);
      this.querySelector('.peak-offer__dismiss').addEventListener('click', () => {
        this.launcher.hidden = true;
        try { sessionStorage.setItem(this.dismissKey, '1'); } catch { /* Storage is optional. */ }
        document.querySelector('#header-component a[href]')?.focus();
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
          .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const first = controls[0];
        const last = controls.at(-1);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }, options);
      this.onResize = () => this.scheduleMeasure();
      window.addEventListener('resize', this.onResize, options);
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.observer = new MutationObserver(() => this.scheduleMeasure());
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.observed = new WeakSet();
      this.scheduleMeasure();
      // Only reopen for this form's own server-returned feedback, never for a timed promotion.
      if (location.hash === `#${this.form.id}` && this.querySelector('[data-offer-feedback]')) this.open();
    }
    open() {
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      this.dialog.showModal();
      this.querySelector('input[type=email]').focus({ preventScroll: true });
    }
    restore() {
      if (this.locked) document.documentElement.style.overflow = this.previousOverflow;
      this.locked = false;
      if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
    }
    scheduleMeasure() {
      if (this.measureFrame) return;
      this.measureFrame = requestAnimationFrame(() => {
        this.measureFrame = null;
        let tools = 0;
        let sticky = 0;
        document.querySelectorAll('#PBarNextFrameWrapper, #PBarNextFrame, sticky-add-to-cart, .sticky-add-to-cart').forEach(element => {
          if (!this.observed.has(element)) {
            this.observed.add(element);
            this.resizeObserver.observe(element);
          }
          const rect = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.visibility === 'hidden' || rect.height <= 0) return;
          // Measure the clipped toolbar wrapper, not its full-viewport iframe.
          if (element.id === 'PBarNextFrameWrapper') tools = Math.max(tools, rect.height);
          else if (element.id === 'PBarNextFrame') {
            if (!document.getElementById('PBarNextFrameWrapper')) tools = Math.max(tools, Math.min(rect.height, 80));
          }
          else if (['fixed', 'sticky'].includes(style.position) && rect.bottom >= innerHeight - 4) sticky = Math.max(sticky, rect.height);
        });
        this.style.setProperty('--peak-offer-tools-height', `${Math.ceil(tools)}px`);
        this.style.setProperty('--peak-offer-sticky-height', `${Math.ceil(sticky)}px`);
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restore();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.measureFrame) cancelAnimationFrame(this.measureFrame);
      this.measureFrame = null;
    }
  });
}
